<template>
  <b-row>
    <b-col cols="12">
      <holiday-edit-form />
    </b-col>
  </b-row>
</template>

<script>
import { BRow, BCol } from 'bootstrap-vue'
import HolidayEditForm from './HolidayEditForm.vue'

export default {
  components: {
    BRow,
    BCol,
    HolidayEditForm,
  },
}
</script>

<style lang="scss">
    @import '@core/scss/vue/libs/vue-wizard.scss';
    @import '@core/scss/vue/libs/vue-select.scss';
</style>
